// extracted by mini-css-extract-plugin
module.exports = {"slideWrapper":"wx","imageWrapper":"wy","image":"wz","copyrightAndBrandLogo":"wA","brandLogo":"wB","copyright":"wC","rentalBadge":"wD"};